import { render, staticRenderFns } from "./SelectGuardian.vue?vue&type=template&id=640d064a&scoped=true&"
import script from "./SelectGuardian.vue?vue&type=script&lang=js&"
export * from "./SelectGuardian.vue?vue&type=script&lang=js&"
import style0 from "./SelectGuardian.vue?vue&type=style&index=0&id=640d064a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d064a",
  null
  
)

export default component.exports